<rx-applications-all-filters-list
  [isLoadingLocation]="resultsFacade.isLoadingLocation$ | async"
  [isFilterPanelExpanded]="filterFacade.isFilterPanelExpanded$ | async"
  [popularFiltersList]="popularFiltersList$ | async"
  [freeCancellationFilter]="freeCancellationFilter$ | async"
  [mealOptionFilters]="mealOptionFilters"
  [loyaltyProgramFilter]="loyaltyProgramFilter$ | async"
  [parkingFiltersList]="parkingFiltersList$ | async"
  [otherFiltersList]="otherFiltersList$ | async"
  [starRatingCheckboxes]="filterFacade.starRatingCheckboxes$ | async"
  [unfilteredCount]="resultsFacade.unfilteredCount$ | async"
  [selectedCurrency]="configFacade.selectedCurrency$ | async"
  [selectedPriceRange]="filterFacade.selectedPriceRange$ | async"
  [priceMinMax]="filterFacade.minMax$ | async"
  [numberOfNights]="routerFacade.numberOfNights$ | async"
  [propertyTypeFilters]="filterFacade.propertyTypeFilter$ | async"
  [additionalPropertyTypeFilters]="filterFacade.additionalPropertyTypeFilter$ | async"
  (rateFilterSelect)="onRateFilterSelect($event)"
  (mealOptionSelect)="onMealOptionSelect($event.mealOptions, $event.mealOption)"
  (loyaltyProgramFilterSelect)="onLoyaltyProgramFilterSelect($event)"
  (amenitySelect)="onAmenitySelect($event)"
  (propertyTypeSelect)="onPropertyTypeSelect($event)"
  (selectAllPropertyTypeSelect)="onSelectAllPropertyTypeSelect($event)"
  (priceRangeFilterChange)="onPriceRangeFilterChange($event)"
  (priceRangeInteractions)="onPriceRangeInteractions($event)"
  (starSelect)="onStarSelect($event)"
/>
